import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams } from 'ionic-angular';
import { CommingSoonPage } from '../comming-soon/comming-soon';
import { EmiPmiPaymentsPage } from '../emi-pmi-payments/emi-pmi-payments';
import { OthersPaymentsPage } from '../others-payments/others-payments';

/**
 * Generated class for the PaymentsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-payments',
  templateUrl: 'payments.html',
})
export class PaymentsPage {
  
  tab1Root:any=EmiPmiPaymentsPage
  tab2Root:any=OthersPaymentsPage
  arrPaymentsSummary: any=[];
  repaymentDetails:any
  soaSummary:any

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public events:Events) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad PaymentsPage',this.navParams);
     
    this.ionSelected()
    
  }
  ionSelected(){
    //console.log("selected");
  }

}



// WEBPACK FOOTER //
// ./src/pages/payments/payments.ts